export const PAGE_SIZE_OPTIONS = [25, 50, 100];

/**
 * ページ番号の表示用配列（省略記号付き）
 */
export function getVisiblePageNumbers(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = new Set([1, total]);
  for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i += 1) {
    pages.add(i);
  }
  const sorted = [...pages].sort((a, b) => a - b);
  const result = [];
  for (let i = 0; i < sorted.length; i += 1) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push('...');
    result.push(sorted[i]);
  }
  return result;
}

export function getPageRangeLabel(currentPage, pageSize, total) {
  if (total <= 0) return '0件';
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, total);
  return `${start}–${end} / ${total}件`;
}

/** 総件数が不明なカーソルページング用の件数ラベル */
export function getCursorPageRangeLabel(currentPage, pageSize, itemCount, { hasMore = false, maxKnownPage = currentPage } = {}) {
  if (itemCount <= 0) return '0件';
  const start = (currentPage - 1) * pageSize + 1;
  const end = start + itemCount - 1;
  const reachedEnd = currentPage >= maxKnownPage && !hasMore;
  return reachedEnd ? `${start}–${end}件` : `${start}–${end}件〜`;
}

/** 既知ページ数 + 続きがある場合の仮の最終ページ */
export function getCursorSoftTotalPages(maxKnownPage, hasMore) {
  const known = Math.max(1, maxKnownPage || 1);
  return hasMore ? known + 1 : known;
}
